<template>
    <!-- Start Why Choose Us Section -->
		<div class="why-choose-section bg-light rounded" style="width: 95%;z-index: 1;" data-aos="fade-right" data-aos-duration="500" data-aos-easing="ease-in-sine">
			<div class="container">
				<div class="row justify-content-between">
					<div class="col-lg-6">
						<h2 class="section-title">Lợi thế khi chọn chúng tôi</h2>
						<p>{{ data['main'] }}</p>

						<div class="row my-5">
							<div class="col-6 col-md-6">
								<div class="feature">
									<div class="icon">
										<img src="images/truck.svg" alt="Image" class="imf-fluid">
									</div>
									<p style="white-space: pre-line;text-align: justify;">{{ data['first'] }}</p>
								</div>
							</div>

							<div class="col-6 col-md-6">
								<div class="feature">
									<div class="icon">
										<img src="images/bag.svg" alt="Image" class="imf-fluid">
									</div>
									<p style="white-space: pre-line;text-align: justify;">{{ data['second'] }}</p>
								</div>
							</div>

							<div class="col-6 col-md-6">
								<div class="feature">
									<div class="icon">
										<img src="images/support.svg" alt="Image" class="imf-fluid">
									</div>
									<p style="white-space: pre-line;text-align: justify;">{{ data['third'] }}</p>
								</div>
							</div>

							<div class="col-6 col-md-6">
								<div class="feature">
									<div class="icon">
										<img src="images/return.svg" alt="Image" class="imf-fluid">
									</div>
									<p style="white-space: pre-line;text-align: justify;">{{ data['fourth'] }}</p>
								</div>
							</div>

						</div>
					</div>

					<div class="col-lg-5">
						<div class="img-wrap">
							<img :src="data['url']" alt="Image" class="img-fluid">
						</div>
					</div>

				</div>
			</div>
		</div>
	<!-- End Why Choose Us Section -->
</template>

<script>
    import { ref, onValue } from "firebase/database";
    import { database } from '../../components/firebase'

    export default{
        data(){
            return{
                data:[],
            }
        },
        mounted(){
            const ReasonRef = ref(database, 'Reason/');
            onValue(ReasonRef, (snapshot) => {
                this.data = snapshot.val();
                // console.log(this.data);
            });
        }
    }
</script>